export default __webpack_public_path__ + "static/media/message.2af98e84.svg";